/*
 * Card product – scroll reveal (Maple, Sept 2026)
 * As shoppers scroll, each product card fades to its 2nd (lifestyle) image
 * once the card is ~60% in view (no hover needed), and back when it leaves.
 * - Works on mobile and desktop. Set MOBILE_ONLY = true to limit to touch devices.
 * - Only swaps once the real 2nd image has loaded (not the theme's preload.gif).
 * - Picks up cards added later (recommendations, predictive search, sliders).
 */
(function () {
  var MOBILE_ONLY = false;
  var REVEAL_DELAY = 250; // ms after a card settles in view before the swap

  if (!('IntersectionObserver' in window)) return;
  if (MOBILE_ONLY && !window.matchMedia('(hover: none)').matches) return;

  var READY = 'hover-ready';
  var INVIEW = 'is-inview';

  function isLoaded(img) {
    var src = img.currentSrc || img.src || '';
    return img.complete && img.naturalWidth > 1 && src.indexOf('preload') === -1;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var card = entry.target;
      clearTimeout(card._revealTimer);
      if (entry.isIntersecting) {
        card._revealTimer = setTimeout(function () { card.classList.add(INVIEW); }, REVEAL_DELAY);
      } else {
        card.classList.remove(INVIEW);
      }
    });
  }, { threshold: 0.6 });

  function setup(card) {
    if (card.dataset.scrollReveal) return;
    var img = card.querySelector('.card-product__media .hover-image');
    if (!img) return;
    card.dataset.scrollReveal = '1';

    function check() {
      if (isLoaded(img)) {
        card.classList.add(READY);
        img.removeEventListener('load', onLoad);
      }
    }
    // The theme's lazy-loader swaps preload.gif -> real image; wait a tick after
    // each load so its own onload handler has run first.
    function onLoad() { setTimeout(check, 0); }

    img.addEventListener('load', onLoad);
    check();
    io.observe(card);
  }

  function scan(root) {
    if (root.matches && root.matches('.card-product')) setup(root);
    if (root.querySelectorAll) root.querySelectorAll('.card-product').forEach(setup);
  }

  function init() {
    scan(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) scan(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
